<!-- 联系我们 -->
<template>
  <div class="box">
    <!-- 头部 -->
    <div class="header">
      <div class="headerContent">
        <div class="left">
          <img src="..\assets\img\logo.png" alt="">
          烟雨佳人
        </div>
        <div class="right">
          <button @click="$router.push('/download')">下载客户端</button>
          <button style="margin-left:15px" @click="$router.push('/')">首页</button>
        </div>
      </div>
    </div>
    <!-- 主体 -->
    <div class="main">
      <div class="mianContent">
        <div class="left" style="float: left;width: 380px">
          <div class="imgBox"></div>
          <!-- <img src="..\assets\img\1.1.png" alt="" style="width: 360px;margin-top: 80px"> -->
        </div>
        <div class="right" style="float: right;width: 500px;">
          <h1>联系我们</h1>
          <strong style="font-size: 18px;">联系方式</strong>
          <p style="font-size: 18px;">yyjrapp@163.com</p>
          <h1>公司介绍</h1>
          <p style="font-size: 18px;margin-bottom: 40px">沈阳恭赢高新科技有限公司是一家移动互联网公司，致力于打造轻奢高品质社交平台，满足现代多样化的社交需求。
            烟雨佳人是一款致力于高品质交友的社交软件。在这里你可以展示真实的自我，释放心情。
            认识近的或远的、懂你的或有趣的人。世界这么大，烟雨佳人让你在茫茫人海中不再感到孤独，每一个日与夜都有人陪伴。</p>
          <strong>【世界动态 随时随地分享生活乐趣】</strong>
          <p>在这里可以看到世界各地人士发布的动态，发现有趣的人和事，你也可以通过图片、视频分享生活中的高光时刻。</p>
          <strong>【同城附近推荐 遇见你的心动】</strong>
          <p>根据定位距离由近到远推荐同城附近的好友，聊天、约会见面，距离不是问题。</p>
          <strong>【资料主页 多面展示你的独特】</strong>
          <p>多面了解TA的信息，在茫茫人海中寻觅那个与你灵魂最契合的人。</p>
          <strong>【趣味聊天 遇见懂你的人】</strong>
          <p>可通过发送文字、语音、图片、视频功能，多步互动增加好感，结交有趣的灵魂，分享你的喜怒哀乐，释放自我。</p>
          <strong>【个人中心 信息展示多样化】</strong>
          <p>信息展示多样化，我的形象我做主，功能大全都在这里，想点哪里一目了然，想怎么玩就怎么玩。</p>
        </div>
      </div>
      <!-- 底部 -->
      <div class="food">
        <p>2020-2021 © All Rights Reserved. 烟雨佳人APP&nbsp;&nbsp;湘ICP备2022026309号</p>
        <p>违法和不良信息举报邮箱：yyjrapp@163.com</p>
        <p><img src="..\assets\img\beianIcon.png" alt="" style="vertical-align: middle;"><a style="color: #b0aab3;" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=21010402000369" target="_blank" rel="noopener noreferrer"> @百星文化</a></p>
      </div>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件 (比如：组件，工具js，第三方插件js，json文件，图片文件等等)
  // 例如：import 《组件名称》 from '《组件路径》'
  export default {
    name: "contactUs",
    // import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      // 这里存放数据
      return {};
    },
    // 计算属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      // 判断是PC端还是移动端
      IsPC: function () {
        // 当前设备信息
        let userAgentInfo = navigator.userAgent;
        let Agents = [
          "Android",
          "iPhone",
          "SymbianOS",
          "Windows Phone",
          "iPad",
          "iPod",
          "webOS",
          "BlackBerry"
        ];
        let flag = true;
        // 如果能匹配到上面的字符串 就说明是移动端
        for (let v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
          }
        };
        // true为PC端 false为移动端
        return flag;
      }
    },
    // 生命周期 - 创建完成 (可以访问当前this实例)
    created() {},
    // 生命周期 - 挂载完成 (可以访问DOM元素)
    mounted() {
      // 如果是移动端 直接跳转至手机下载页面
      if (!this.IsPC()) {
        this.$router.push('/download');
        return false;
      }
    },
    // 生命周期 - 销毁之前
    beforeDestroy() {},
    // 生命周期 - 销毁完成
    destroyed() {},
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* @import url(路径); 引入公共css类 */
  /* font-family: SourceHanSansBold; */
  /* font-family: SourceHanSansRegular; */
  .box {
    background-color: #181818;
  }

  /* 头部 */
  .header {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    height: 60px;
    box-shadow: 0 0 10px 0 #ccc;
    background-color: #fff;
  }

  .headerContent {
    width: 960px;
    height: 60px;
    line-height: 60px;
    margin: 0 auto;
  }

  .headerContent .left {
    float: left;
    font-size: 20px;
  }

  .headerContent .left img {
    display: inline-block;
    border-radius: 10px;
    height: 40px;
    width: 40px;
    vertical-align: middle;
  }

  .headerContent .right {
    float: right;
  }

  .headerContent .right button {
    border: 1px solid #d6ced9;
    color: #5e5063;
    background-color: #fff;
    padding: 5px 15px;
    cursor: pointer;
  }

  /* 主体 */
  .main {
    padding-top: 60px;
  }

  .main .mianContent {
    width: 950px;
    height: 950px;
    padding: 30px 80px;
    margin: 20px auto 0 auto;
    background-color: #343434;
    border-radius: 10px;
    overflow: hidden;
  }

  .main .mianContent .left .imgBox {
    margin-top: 100px;
    width: 360px;
    height: 725px;
    background-image: url(..\assets\img\1.1.png);
    background-size: 100% 102%;
    background-position: center;
    box-shadow: 0 0px 10px 10px #202020;
    border-radius: 50px;
  }

  .main .mianContent .right h1 {
    padding: 20px 0;
    color: #eee;
  }

  .main .mianContent .right strong {
    display: block;
    margin: 10px 0;
    color: #eee;

  }

  .main .mianContent .right p,
  .main .mianContent .right strong {
    font-size: 16px;
    color: #eee;

  }

  /* 底部 */
  .food {
    padding: 20px 0;
    color: #b0aab3;
    text-align: center;
    font-size: 14px;
  }

  /* 小于 1024px 时的样式 */
  @media screen and (max-width: 1024px) {}
</style>


// WEBPACK FOOTER //
// src/components/contactUs.vue